import React, { useEffect, useState } from "react";
import {
  Create as BaseCreate,
  SimpleForm,
  SelectInput,
  required,
  useGetOne,
  ReferenceInput,
  ArrayInput,
  SimpleFormIterator,
  useChoicesContext,
  NumberInput,
  useCreate,
  BooleanInput,
  TextInput,
  useNotify,
  Button,
  useDataProvider,
  usePermissions,
  AutocompleteInput,
  Toolbar,
  SaveButton,
} from "react-admin";
import moment from "moment";
import { es } from "date-fns/locale";
import { useFormContext, useWatch } from "react-hook-form";
import { SelectCustomerInput } from "./SelectCustomer";
import { DateInput } from "../components/DatePicker";
import { toHoursAndMinutes } from "../util";
import TextField from "@mui/material/TextField";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Autocomplete,
  CircularProgress,
  Typography,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";
import { useProvider } from "../ProviderContext";

const paymentMethods = [
  { id: "Efectivo", name: "Efectivo" },
  { id: "Tarjeta", name: "Tarjeta" },
  { id: "QR", name: "QR" },
  { id: "Tigo Money", name: "Tigo Money" },
  { id: "Cortesia", name: "Cortesia" },
  { id: "Gift Card", name: "Gift Card" },
];

const AvailableDateInput = ({
  availability,
  blockedDates,
  busyDates,
  branchAvailability,
  setIsDateBlocked,
  fullbusyDates,
  ...props
}) => {
  console.log("AVAILABILITY", availability);
  console.log("Bloqued dates", blockedDates);
  console.log("Full busy dates", fullbusyDates);
  console.log("branchAvailability", branchAvailability);
  console.log("setIsDateBlocked", setIsDateBlocked);
  console.log("fullbusyDates", fullbusyDates);
  const [searchParams, setSearchParams] = useSearchParams();
  const button = searchParams.get("type");
  return (
    <DateInput
      validate={[required()]}
      source="date"
      label="Fecha de reserva"
      inputVariant="outlined"
      options={{
        format: "dd/MM/YYY",
        clearable: true,
        disablePast: button !== "sobreHorario",
      }}
      providerOptions={{ locale: es }}
      shouldDisableDate={(day) => {
        const dateMoment = moment(day);
        if (button === "sobreHorario") {
          return false;
        }
        if (dateMoment.isBefore(moment().startOf("day"))) {
          return true;
        }
        if (fullbusyDates.includes(dateMoment.format("YYYY-MM-DD"))) {
          return true;
        }
        if (blockedDates.some((blockedDate) => dateMoment.isSame(blockedDate, "day"))) {
          return true;
        }
        const dayIndex = dateMoment.isoWeekday() - 1;
        if (!availability[dayIndex] || availability[dayIndex].length === 0) {
          return true;
        }
        return false;
      }}
      setIsDateBlocked={setIsDateBlocked}
      {...props}
    />
  );
};

const HourInput = ({ availability, branchAvailability, isDateBlocked }) => {
  const { permissions } = usePermissions();
  const { watch, setValue } = useFormContext();
  const date = watch("date");
  const editedEstimatedWorkMinutes = watch("editedEstimatedWorkMinutes");
  const [hourPicker, setHourPicker] = useState([]);
  const serviceCart = useFormContext().watch("serviceCart");
  const employee = useFormContext().watch("employee");
  const { provider } = useProvider();
  const totalEstimatedWorkMinutes =
    editedEstimatedWorkMinutes ??
    serviceCart?.reduce(
      (a, b) => a?.unitEstimatedWorkMinutes * a?.quantity || a + b?.unitEstimatedWorkMinutes * b?.quantity,
      0
    ) ??
    0;
  console.log("Log de preuba");
  useEffect(() => {
    _setHourPicker(moment(date));
    setValue("hour", "");
  }, [date, totalEstimatedWorkMinutes, employee]);

  const [searchParams] = useSearchParams();
  const button = searchParams.get("type");

  useEffect(() => {
    if (searchParams.get("date")) {
      setValue("date", new Date(searchParams.get("date")));
    }
  }, [searchParams.get("date")]);

  const [fetchAvailability, { isLoading, error }] = useCreate();

  const _setHourPicker = async (date) => {
    const array = [];
    if (button === "sobreHorario") {
      const array = [];
      let currentHour = 0;
      const intervalInHours = (provider?.intervalMinutes || 30) / 60; // Convertir minutos a horas

      while (currentHour < 24) {
        const hours = Math.floor(currentHour);
        const minutes = (currentHour % 1) * 60;

        array.push({
          id: currentHour,
          name: moment().hour(hours).minute(minutes).format("HH:mm"),
        });

        currentHour += intervalInHours;
      }
      setHourPicker(array);
    } else {
      const today = moment();
      const isSameDay = moment(today).isSame(date, "day");
      const providerId =
        permissions === "admin-sucursal"
          ? JSON.parse(localStorage.getItem("profile")).employer._id
          : JSON.parse(localStorage.getItem("profile"))._id;
      await fetchAvailability(
        "dateAvailability/" + providerId,
        {
          data: {
            date: date,
            estimatedTime: totalEstimatedWorkMinutes,
            isInBranch: watch("isInBranch"),
            branch: watch("branch")?._id,
            employee: watch("employee")?._id,
            serviceCart: serviceCart?.map((e) => e._id) ?? [],
          },
        },
        {
          onSuccess: (response) => {
            response.data.availability.map((e) => {
              const _date = moment(e);
              if (isSameDay && _date.hours() <= today.hours()) {
                // return;
              }
              array.push({
                id: _date.hours() + _date.minutes() / 60,
                name: _date.format("HH:mm"),
              });
            });
            setHourPicker(array);
          },
        }
      );
    }
  };
  return (
    <SelectInput
      validate={[required()]}
      source="hour"
      label="Hora"
      choices={hourPicker}
      disabled={hourPicker.length === 0 || serviceCart.length === 0 || isDateBlocked}
      helperText={isDateBlocked || hourPicker.length === 0 ? "Sin horarios disponibles en esa fecha." : ""}
      data-cy="booking-hour"
      sx={{
        "& .MuiInputBase-root": {
          width: "244px",
        },
      }}
    />
  );
};

export const Create = (props) => {
  const initAvailability = {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  };
  const [searchParams] = useSearchParams();
  const [courtesyValue, setCourtesyValue] = useState(Number(1));
  const [availability, setAvailability] = useState(initAvailability);
  const { permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const [blockedDates, setBlockedDates] = useState([]);
  const [busyDates, setBusyDates] = useState([]);
  const [fullbusyDates, setFullBusyDates] = useState([]);
  const [branchAvailability, setBranchAvailability] = useState(null);
  const button = searchParams.get("type");
  const [isDateBlocked, setIsDateBlocked] = useState(false);
  const [isPriceVariable, setIsPriceVariable] = useState(false);

  useEffect(() => {
    if (button === "sobreHorario") {
      fetchAvailabilityData();
    }
  }, [button]);

  const fetchAvailabilityData = async () => {
    const token = localStorage.getItem("token"); // Obtener el token del localStorage

    if (!token) {
      console.error("Token no encontrado en el localStorage");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/availabilityWeb/0`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data) {
        setBranchAvailability(data.data.availability); // Almacenamos la disponibilidad
      }
    } catch (error) {
      console.error("Error fetching availability data", error);
    }
  };
  const transform = async (data) => {
    const profile = JSON.parse(localStorage.getItem("profile"));
    const messageToSend = JSON.parse(localStorage.getItem("profile")).message;
    let provider = profile;

    if (permissions === "admin-sucursal") {
      provider = profile.employer;
      try {
        const response = await dataProvider.getOne("providers", { id: profile.employer._id });
        provider = response.data; // Ahora 'provider' será el dato resuelto de la promesa
      } catch (error) {
        console.error("error", error);
      }
    }
    const { countryCode, ...restCustomer } = data.customer;
    const booking = {
      ...data,
      serviceCart: data.serviceCart.map((e) => {
        return {
          service: e,
          quantity: e.quantity,
          price: e.quantity * e.unitPrice,
          estimatedWorkMinutes: e.quantity * e.unitEstimatedWorkMinutes,
        };
      }),
      paymentInfo: {
        totalPrice:
          (1 - (data.discountPercentage || 0) / 100) *
            data.serviceCart?.reduce(
              (a, b) => a.unitPrice * a.quantity || a + (b.unitPrice || 0) * (b.quantity || 0),
              0
            ) -
            data.discountAmount || 0,
        paymentMethod: data.paymentInfo?.paymentMethod || "Efectivo",
        couponCode: data.paymentInfo?.couponCode,
        couponType: data.paymentInfo?.couponType,
        couponValue: data.paymentInfo?.couponValue,
        sobreHorario: button === "sobreHorario",
      },
      whatsappSettings: {
        sendOnCreate: data.whatsappSettings?.sendOnCreate ?? true,
        sendOnFinish: data.whatsappSettings?.sendOnFinish ?? true,
        sendQRCode: data.whatsappSettings?.sendQRCode ?? true,
        sendOnCancel: data.whatsappSettings?.sendOnCancel ?? true,
      },
      totalEstimatedWorkMinutes:
        data.editedEstimatedWorkMinutes ??
        data.serviceCart?.reduce(
          (a, b) =>
            a.unitEstimatedWorkMinutes * a.quantity || a + (b.unitEstimatedWorkMinutes || 0) * (b.quantity || 0),
          0
        ),
      totalEstimatedWorkMinutes:
        data.editedEstimatedWorkMinutes ??
        data.serviceCart?.reduce(
          (a, b) =>
            a.unitEstimatedWorkMinutes * a.quantity || a + (b.unitEstimatedWorkMinutes || 0) * (b.quantity || 0),
          0
        ),
      bookingDate: moment(data.date)
        .hours(data.hour)
        .minutes((data.hour % 1) * 60)
        .format(),
      createdAt: moment().format(),
      customer: {
        ...restCustomer,
        address: data.address,
        codePhone: countryCode,
      },
      status: data.isPriceVariable ? "Pendiente de cotización" : "Confirmado",
      provider: {
        ...provider,
        name: provider.first_name,
        logoURL: provider.picture,
      },
    };
    if (data.employee) {
      booking.employee = {
        ...data.employee,
        fullName: data.employee.first_name + " " + data.employee.last_name,
        photoURL: data.employee.picture,
        CI: data.employee.CI_NIT,
        pushToken: data.employee.pushToken,
      };
    }

    if (data.customer?.reminderEnabled && messageToSend) {
      booking.reminder = {
        isActive: true,
        message: messageToSend,
        isDone: false,
        totalToSend: data.serviceCart.length,
        alreadySent: 0,
        datesInfo: [],
      };
    }

    return booking;
  };

  const handlerChange = (e) => {
    if (e.target.value === "Cortesia") setCourtesyValue(Number(0));
    else setCourtesyValue(Number(1));
  };
  const handlerChange2 = (e) => {
    if (e.target.value === "Pendiente de cotización") setIsPriceVariable(true);
    else setIsPriceVariable(false);
  };

  return (
    <BaseCreate
      {...props}
      transform={transform}
      redirect={(resource, id, data, state) => {
        const branch = data?.branch?._id ?? null;
        const formattedDate = new Date(data.date).toISOString();
        let redirectParam = searchParams.get("redirect")
          ? searchParams.get("redirect") +
            "?date=" +
            formattedDate +
            "&employee=" +
            data.employee?._id +
            "&serviceMethod=" +
            searchParams.get("serviceMethod")
          : null;
        if (redirectParam && branch) {
          redirectParam += "&branch=" + branch;
        }

        if (redirectParam) {
          return redirectParam;
        }

        return "booking";
      }}
    >
      <SimpleForm
        data-cy="booking-create-form"
        toolbar={
          <Toolbar>
            <SaveButton data-cy="booking-save" />
          </Toolbar>
        }
      >
        <BooleanInput
          source="isInBranch"
          defaultValue={searchParams.get("serviceMethod") !== "A domicilio" ?? false}
          label="¿Servicio en Sucursal?"
          sx={{ width: "50%" }}
          data-cy="booking-in-branch"
        />
        <ReferenceInput
          label="Sucursal"
          source="branch"
          reference="enterprise/branches"
          filter={{
            status: true,
          }}
          sx={{ width: "50%" }}
        >
          <SelectBranchInput />
        </ReferenceInput>
        <SelectCustomerInput sx={{ width: "50%" }} />
        <ArrayInput validate={[required()]} source="serviceCart" label="CARRITO" style={{ margin: "1rem 0" }}>
          <SimpleFormIterator disableReordering>
            <ReferenceInput reference="service" filter={{ enabled: true }}>
              <SelectServiceInput courtesyValue={courtesyValue} />
            </ReferenceInput>
          </SimpleFormIterator>
        </ArrayInput>
        <TotalFields courtesyValue={courtesyValue} />
        <SelectInput
          source="isPriceVariable"
          label="Estado de reserva"
          choices={[
            { id: true, name: "Pendiente de cotización" },
            { id: false, name: "Confirmado" },
          ]}
          onChange={handlerChange2}
          defaultValue={false}
          data-cy="booking-status"
        />
        <SelectInput
          source="paymentInfo.paymentMethod"
          label="Método de Pago"
          choices={paymentMethods}
          onChange={handlerChange}
          data-cy="booking-payment-method"
        />
        <ReferenceEmployee
          setAvailability={setAvailability}
          initAvailability={initAvailability}
          setBlockedDates={setBlockedDates}
          setBusyDates={setBusyDates}
          setFullBusyDates={setFullBusyDates}
        />
        <AvailableDateInput
          availability={availability}
          blockedDates={blockedDates}
          busyDates={busyDates}
          branchAvailability={branchAvailability}
          setIsDateBlocked={setIsDateBlocked}
          fullbusyDates={fullbusyDates}
          data-cy="booking-date"
        />
        <br />
        <HourInput availability={availability} branchAvailability={branchAvailability} isDateBlocked={isDateBlocked} />
        <TextInput
          source="createdFrom"
          label="Created From"
          defaultValue="Manual"
          disabled
          style={{ display: "none" }}
        />
        <BooleanInput
          source="whatsappSettings.sendOnCreate"
          label="Enviar WhatsApp al crear reserva"
          defaultValue={true}
        />
        <BooleanInput
          source="whatsappSettings.sendOnFinish"
          label="Enviar WhatsApp al finalizar servicio"
          defaultValue={true}
        />
        <BooleanInput source="whatsappSettings.sendQRCode" label="Enviar código QR por WhatsApp" defaultValue={true} />
        <BooleanInput
          source="whatsappSettings.sendOnCancel"
          label="Enviar WhatsApp al cancelar reserva"
          defaultValue={true}
        />
        <TextInput source="notes" label="Detalles" multiline fullWidth rows={4} data-cy="booking-notes" />
      </SimpleForm>
    </BaseCreate>
  );
};

const SelectEmployeeInput = ({ source, ...props }) => {
  const choicesContext = useChoicesContext();
  const { setValue, watch } = useFormContext();
  const employee = watch("employee");
  const branch = watch("branch");
  const isInBranch = watch("isInBranch");
  const [searchParams] = useSearchParams();
  const [inputValue, setInputValue] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // Filtrar empleados según el contexto (sucursal, método de servicio)
  const availableEmployees = isInBranch
    ? choicesContext.allChoices?.filter((e) => e.branch?._id === branch?._id) || []
    : choicesContext.allChoices?.filter((e) => e.serviceMethod !== "En sucursal") || [];

  // Establecer empleado seleccionado cuando cambia el valor del form
  useEffect(() => {
    if (employee) {
      setSelectedEmployee(employee);
      setInputValue(`${employee.first_name} ${employee.last_name}`);
    } else {
      setSelectedEmployee(null);
      setInputValue("");
    }
  }, [employee]);

  // Establecer empleado por defecto desde searchParams
  useEffect(() => {
    const employeeId = searchParams.get("employee");
    if (employeeId && availableEmployees.length > 0) {
      const defaultEmployee = availableEmployees.find((e) => e._id === employeeId);
      if (defaultEmployee && !selectedEmployee) {
        setSelectedEmployee(defaultEmployee);
        setValue("employee", defaultEmployee);
      }
    }
  }, [availableEmployees, searchParams, selectedEmployee, setValue]);

  const handleEmployeeChange = (event, newValue) => {
    setSelectedEmployee(newValue);
    setValue("employee", newValue || null);
    if (newValue) {
      setInputValue(`${newValue.first_name} ${newValue.last_name}`);
    } else {
      setInputValue("");
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
  };

  return (
    <Autocomplete
      options={availableEmployees}
      value={selectedEmployee}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      onChange={handleEmployeeChange}
      getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        return option._id === value._id;
      }}
      filterOptions={(options, { inputValue }) => {
        if (!inputValue) return options;

        const searchText = inputValue.toLowerCase();
        return options.filter((option) => {
          const fullName = `${option.first_name} ${option.last_name}`.toLowerCase();
          return (
            fullName.includes(searchText) ||
            option.first_name.toLowerCase().includes(searchText) ||
            option.last_name.toLowerCase().includes(searchText)
          );
        });
      }}
      renderInput={(params) => <TextField {...params} label="Empleado" variant="outlined" />}
      sx={{
        width: "244px",
        marginBottom: "8px",
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          {...props}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 12px",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
            <PersonIcon sx={{ color: "#666", marginRight: 1 }} />
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
              {option.first_name} {option.last_name}
            </Typography>
          </Box>

          {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {option.serviceMethod && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <WorkIcon sx={{ color: "#666", fontSize: "16px", marginRight: 0.5 }} />
                <Typography variant="body2" sx={{ color: "#666" }}>
                  {option.serviceMethod}
                </Typography>
              </Box>
            )}
          </Box> */}
        </Box>
      )}
      noOptionsText="No se encontraron empleados"
      clearOnBlur={false}
      disableClearable={false}
      freeSolo={false}
    />
  );
};

const ReferenceEmployee = ({ setAvailability, initAvailability, setBlockedDates, setBusyDates, setFullBusyDates }) => {
  const date = useFormContext().watch("date");
  const hour = useFormContext().watch("hour");
  const serviceCart = useFormContext().watch("serviceCart");
  const isInBranch = useFormContext().watch("isInBranch");
  const branch = useFormContext().watch("branch");
  const [totalEstimatedWorkMinutes, setTotalEstimatedWorkMinutes] = useState(0);
  const [endDate, setEndDate] = useState(moment().format());
  const [bookingDate, setBookingDate] = useState(null);
  const editedEstimatedWorkMinutes = useFormContext().watch("editedEstimatedWorkMinutes");
  const { permissions } = usePermissions();
  const employee = useFormContext().watch("employee");
  const { data: user } = useGetOne("availability", {
    id: employee?._id ?? JSON.parse(localStorage.getItem("profile"))._id,
    meta: { branch: isInBranch ? branch?._id : null },
  });

  const getBlockedDates = (unavailablePeriods) => {
    const blockedDates = [];

    unavailablePeriods.forEach(({ startDate, endDate }) => {
      const start = moment(startDate);
      const end = moment(endDate);

      const startDay = start.clone().startOf("day"); // Día de inicio (00:00)
      const endDay = end.clone().startOf("day"); // Día de fin (00:00)

      while (startDay.isSameOrBefore(endDay)) {
        // Control del primer día
        if (startDay.isSame(start, "day")) {
          if (start.hours() <= 8) {
            blockedDates.push(startDay.clone()); // Bloquear completamente
          }
        }
        // Control del último día
        else if (startDay.isSame(end, "day")) {
          if (end.hours() >= 23) {
            blockedDates.push(startDay.clone()); // Bloquear completamente
          }
        }
        // Días intermedios siempre bloqueados
        else {
          blockedDates.push(startDay.clone());
        }

        startDay.add(1, "day"); // Avanzar un día
      }
    });

    return blockedDates;
  };
  useEffect(() => {
    if (user?.busy) {
      // setBusyDates(getFullyBusyDays(user?.busy));
      setBusyDates(user?.busy);
    }
    if (user?.fullyBusyDays) {
      // setBusyDates(getFullyBusyDays(user?.busy));
      setFullBusyDates(user?.fullyBusyDays);
    }
    if (user?.unavailability) {
      setBlockedDates(getBlockedDates(user?.unavailability));
    }
    if (user?.availability) {
      const _availability = user?.availability?.reduce(
        (array, e) => {
          // Asegurar que array[e.dayIndex] sea un array
          if (!Array.isArray(array[e.dayIndex])) {
            array[e.dayIndex] = [];
          }
          return {
            ...array,
            [e.dayIndex]: [...array[e.dayIndex], e],
          };
        },
        { ...initAvailability }
      );
      setAvailability(_availability);
    }
  }, [user]);

  useEffect(() => {
    if (date && hour) {
      setBookingDate(
        moment(date)
          .hours(hour)
          .minutes((hour % 1) * 60)
          .format()
      );
    }
  }, [date, hour]);
  useEffect(() => {
    if (serviceCart) {
      setTotalEstimatedWorkMinutes(
        editedEstimatedWorkMinutes ??
          serviceCart?.reduce(
            (a, b) => a.unitEstimatedWorkMinutes * a.quantity || a + b.unitEstimatedWorkMinutes * b.quantity,
            0
          )
      );
    }
  }, [JSON.stringify(serviceCart), editedEstimatedWorkMinutes]);

  useEffect(() => {
    setEndDate(moment(bookingDate).add(totalEstimatedWorkMinutes, "minutes").format());
  }, [totalEstimatedWorkMinutes, bookingDate]);

  const profile = JSON.parse(localStorage.getItem("profile"));
  const providerId = permissions === "admin-sucursal" ? profile.employer._id : profile._id;

  return (
    <ReferenceInput
      label="Empleado"
      source="employee"
      reference={"employee/provider/" + providerId}
      filter={{
        // startDate: bookingDate,
        // endDate: endDate,
        // idProv: providerId,
        state: true,
        serviceCart: serviceCart?.map((e) => e._id) ?? [],
        method: isInBranch ? "En sucursal" : "A domicilio",
      }}
    >
      <SelectEmployeeInput />
    </ReferenceInput>
  );
};

const InputUnitPrice = ({ source, label, defaultValue }) => {
  const { setValue, getValues } = useFormContext();
  const [localValue, setLocalValue] = useState("");

  useEffect(() => {
    const initialValue = getValues(source) ?? defaultValue ?? 0;
    setLocalValue(initialValue);
  }, [getValues, source, defaultValue]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setLocalValue(newValue);
    setValue(source, parseFloat(newValue) || 0);
  };

  return (
    <TextField
      label={label}
      value={localValue}
      onChange={handleChange}
      type="number"
      InputProps={{ inputProps: { min: 0 } }}
    />
  );
};

const SelectServiceInput = ({ source, ...props }) => {
  const { courtesyValue } = { ...props };
  const choicesContext = useChoicesContext();

  const isInBranch = useFormContext().watch("isInBranch");
  const branch = useFormContext().watch("branch");

  const service = useWatch({ name: choicesContext.source });

  // Filtrar servicios según si es en sucursal o a domicilio
  const filteredChoices = isInBranch
    ? choicesContext.allChoices?.filter((e) => {
        return branch?.services?.includes(e._id);
      })
    : choicesContext.allChoices;

  return (
    <React.Fragment>
      <AutocompleteInput
        {...props}
        label="Servicio"
        optionText="name"
        optionValue="_id"
        parse={(value) => {
          const selectedService = choicesContext?.allChoices.find((e) => e._id === value);
          if (selectedService) {
            return {
              ...selectedService,
              quantity: service?.quantity || 1,
            };
          }
          return value;
        }}
        format={(value) => {
          if (typeof value === "string") {
            return value;
          }
          return value?._id || "";
        }}
        source={choicesContext.source}
        choices={filteredChoices}
        filterToQuery={(text) => ({
          filter: JSON.stringify({
            $or: [{ name: { $regex: text, $options: "i" } }],
          }),
        })}
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            fontSize: "1rem",
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            padding: "0 !important",
          },
          "& .MuiInputLabel-root": {
            fontSize: "1rem",
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
          },
          "& .MuiInputBase-input": {
            fontSize: "1rem",
            fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            padding: "15px 14px !important",
          },
          "& .MuiAutocomplete-input": {
            padding: "15px 14px !important",
          },
          "& .MuiAutocomplete-inputRoot": {
            padding: "0 !important",
          },
          "& .MuiInputBase-inputAdornedEnd": {
            padding: "15px 14px !important",
            paddingRight: "32px !important",
          },
        }}
      />
      <NumberInput source={choicesContext.source + ".quantity"} step={1} defaultValue={1} label="Cantidad" />

      <Box sx={{ "& div": { m: 1 } }}>
        <InputUnitPrice
          source={choicesContext.source + ".unitPrice"}
          label="Precio Unitario (Bs.)"
          defaultValue={service.unitPrice}
        />
        <TextField
          disabled
          defaultValue={0}
          value={service.unitPrice * service.quantity * courtesyValue || 0}
          label="Subtotal (Bs.)"
        />
      </Box>
      <br />
      <Box sx={{ "& div": { m: 1 } }}>
        <TextField
          disabled
          defaultValue="0:00"
          value={toHoursAndMinutes(service.unitEstimatedWorkMinutes || 0)}
          label="Tiempo Estimado Unitario (h)"
        />
        <TextField
          disabled
          defaultValue={0}
          value={toHoursAndMinutes(service.unitEstimatedWorkMinutes * service.quantity || 0)}
          label="Subtotal (h)"
        />
      </Box>
      <br />
    </React.Fragment>
  );
};

const TotalFields = ({ ...props }) => {
  const { courtesyValue } = { ...props };
  const serviceCart = useFormContext().watch("serviceCart");
  const { watch, setValue } = useFormContext();
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [couponCode, setCouponCode] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const { provider: providerContext } = useProvider();
  const intervalMinutes = providerContext?.intervalMinutes || 30;

  // Validación personalizada para tiempo estimado
  const validateEstimatedTime = (value) => {
    if (!value || value === 0) {
      return "El tiempo de servicio estimado debe ser mayor a 0 minutos";
    }
    return undefined;
  };

  // Generar choices dinámicamente según intervalMinutes
  const maxMinutes = 8 * 60; // 8 horas máximo
  const choices = Array.from({ length: Math.floor(maxMinutes / intervalMinutes) + 1 }, (_, i) => {
    const value = i * intervalMinutes;
    let name;
    if (value === 0) {
      name = "0 Minutos";
    } else if (value < 60) {
      name = `${value} Minutos`;
    } else if (value % 60 === 0) {
      name = `${value / 60} Hora${value === 60 ? "" : "s"}`;
    } else {
      name = `${Math.floor(value / 60)} Hora${Math.floor(value / 60) > 1 ? "s" : ""} ${value % 60} Minutos`;
    }
    return { id: value, name };
  }).filter((choice) => choice.id > 0); // Filtrar para excluir 0 minutos

  const handleVerifyCoupon = () => {
    const serviceCartToSend = serviceCart.map((service) => service._id);

    const bodyData = {
      code: couponCode,
      services: serviceCartToSend,
      customerId: watch("customer")?._id,
    };
    dataProvider
      .create("coupon/verify", { data: bodyData })
      .then(({ data }) => {
        if (data.valid) {
          setValue("paymentInfo.couponCode", data.coupon.code);
          setValue("paymentInfo.couponType", data.coupon.discountType);
          setValue("paymentInfo.couponValue", data.coupon.discount);
          if (data.coupon.discountType == "Porcentaje") {
            setDiscountPercentage(data.coupon.discount || 0);
            setValue("discountPercentage", data.coupon.discount || 0);
            setValue("discountAmount", 0);
            setDiscountAmount(0);
          } else {
            setDiscountAmount(data.coupon.discount || 0);
            setValue("discountAmount", data.coupon.discount || 0);
            setValue("discountPercentage", 0);
            setDiscountPercentage(0);
          }
        } else {
          notify("Cupón inválido o ya usado.", "warning");
        }
      })
      .catch((error) => {
        notify("Cupón no válido.", "error");
      });

    setOpenDialog(false);
  };

  useEffect(() => {
    if (serviceCart) {
      setValue(
        "editedEstimatedWorkMinutes",
        serviceCart?.reduce(
          (a, b) =>
            a.unitEstimatedWorkMinutes * a.quantity || a + (b.unitEstimatedWorkMinutes || 0) * (b.quantity || 0),
          0
        ) || 0
      );
    }
  }, [JSON.stringify(serviceCart)]);

  return (
    <>
      <Box sx={{ "& div": { m: 1 }, display: "flex" }}>
        <TextField label="Código de Cupón" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />
        <Button onClick={() => setOpenDialog(true)} sx={{ fontSize: "1rem" }}>
          Aplicar Cupón
        </Button>
      </Box>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Aplicar Cupón</DialogTitle>
        <DialogContent>¿Desea verificar y aplicar el descuento del cupón {couponCode}?</DialogContent>
        <DialogActions>
          <Button onClick={handleVerifyCoupon} color="primary">
            Verificar
          </Button>
          <Button onClick={() => setOpenDialog(false)} color="secondary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ "& div": { m: 1 } }}>
        <NumberInput
          source="discountAmount"
          disabled={!!discountPercentage}
          min={0}
          onChange={(e) => {
            setDiscountAmount(Number(e.target.value));
          }}
          value={discountAmount}
          label="Descuento (Bs.)"
        />

        <NumberInput
          source="discountPercentage"
          disabled={!!discountAmount}
          min={0}
          onChange={(e) => {
            setDiscountPercentage(Number(e.target.value));
          }}
          label="Descuento (%)"
        />

        <TextField
          disabled
          value={_.clamp(
            ((1 - discountPercentage / 100) *
              serviceCart?.reduce((a, b) => a.unitPrice * a.quantity || a + (b.unitPrice || 0) * (b.quantity || 0), 0) -
              discountAmount) *
              courtesyValue || 0,
            0,
            Number.MAX_VALUE
          )}
          label="Precio Total (Bs.)"
        />
        <SelectInput
          validate={[required(), validateEstimatedTime]}
          source="editedEstimatedWorkMinutes"
          label="Tiempo de servicio estimado"
          choices={choices}
        />
      </Box>
    </>
  );
};

const SelectBranchInput = ({ source, ...props }) => {
  const choicesContext = useChoicesContext();
  const isInBranch = useFormContext().watch("isInBranch");
  const [searchParams, setSearchParams] = useSearchParams();
  const { permissions } = usePermissions();
  const { setValue } = useFormContext();
  const dataProvider = useDataProvider();

  React.useEffect(() => {
    const profile = JSON.parse(localStorage.getItem("profile"));

    const id = profile?.branch?._id;

    dataProvider
      .getOne("enterprise/branches", { id })
      .then((branch) => {
        if (profile?.role === "admin-sucursal" && branch.data) {
          setValue("branch", branch.data);
        }
      })
      .catch((error) => {
        console.error("error", error);
      });
  }, [setValue]);

  return isInBranch && permissions !== "admin-sucursal" ? (
    <SelectInput
      {...props}
      label="Sucursal"
      optionText={(value) => {
        return value.name;
      }}
      optionValue="_id"
      parse={(value) => {
        return choicesContext?.allChoices.find((e) => e._id === value);
      }}
      format={(value) => {
        return value?._id;
      }}
      validate={[required()]}
      defaultValue={choicesContext?.allChoices.find((e) => e._id === searchParams.get("branch"))}
      sx={{ width: "50%" }}
    />
  ) : (
    <React.Fragment />
  );
};
